(function ($) {$(function(){
    // const loopPlayer1 = $('#preview-player-vide1');
    // const loopPlayer2 = $('#preview-player-vide2');
    const $pmvideo = $('.preview.pm video')
    $pmvideo.on('canplay', function() {
        window.updateDirectorPMVideoSize();
    });

    const directors = $('.director-list li a');
    const $videosContainer = $('.page-template-Directors #preview-player');
    const $fistDirector = $(directors[Math.floor(Math.random()*directors.length)])
    const $firstVideo = $videosContainer.find('video[src="'+ $fistDirector.data('video-loop') +'"]');
    if ($firstVideo.length) {
        $firstVideo.addClass('active')
        $firstVideo.get(0).play()
        $firstVideo.removeClass('opc');
        $fistDirector.addClass('active')
        $firstVideo.on('canplay', function() {
            $videosContainer.find('video').removeClass('opc');
        });
    }
    $videosContainer.find('video').not($firstVideo).each(function(){
        const $this = $(this);
        $this.removeClass('active');
        $this.get(0).pause();
    });
    directors.hover(onEnter, onLeave);
    // loopPlayer1.on('canplay', function() {
    //     loopPlayer1.addClass('active')
    //     loopPlayer2.removeClass('active')
    //     loopPlayer2.get(0).pause()
    // });

    // loopPlayer2.on('canplay', function() {
    //     loopPlayer2.addClass('active')
    //     loopPlayer1.removeClass('active')
    //     loopPlayer1.get(0).pause()
    // });
    function onEnter(){
        const $this = $(this);
        const $videosContainer = $('.page-template-Directors #preview-player');
        const $activeVideo = $videosContainer.find('video.active');
        directors.removeClass('active');

        if ($this.data('video-loop') != $activeVideo.attr('src')) {
            const $matchingVideo = $videosContainer.find('video[src="'+ $this.data('video-loop') +'"]');
            if ($matchingVideo.attr('src')) {
                $matchingVideo.addClass('active');
                $matchingVideo.get(0).play();
                $videosContainer.find('video').not($matchingVideo).each(function(){
                    const $this = $(this);
                    $this.removeClass('active');
                    $this.get(0).pause();
                });
            }
        }
            
        // if (loopPlayer1.get(0).paused) {
        //     if (loopPlayer2.attr('src') != $this.data('video-loop')) {
        //         loopPlayer1.attr('src', $this.data('video-loop'));
        //     }
        // } else {
        //     if (loopPlayer1.attr('src') != $this.data('video-loop')) {
        //         loopPlayer2.attr('src', $this.data('video-loop'));
        //     }
        // }
    }
    function onLeave(){
        $(this).addClass('active');
    }
});}(_jQ3));

